@file:OptIn(InternalResourceApi::class)

package swetgram.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/swetgram.shared.generated.resources/"

@delegate:ResourceContentHash(-289_569_604)
internal val Res.string.auth_banner_account_suspended: StringResource by lazy {
      StringResource("string:auth_banner_account_suspended", "auth_banner_account_suspended", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 1921, 217),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1583, 157),
      ))
    }

@delegate:ResourceContentHash(1_272_400_691)
internal val Res.string.auth_banner_code_rejected: StringResource by lazy {
      StringResource("string:auth_banner_code_rejected", "auth_banner_code_rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 2139, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1741, 85),
      ))
    }

@delegate:ResourceContentHash(851_404_105)
internal val Res.string.auth_banner_invalid_credentials: StringResource by lazy {
      StringResource("string:auth_banner_invalid_credentials", "auth_banner_invalid_credentials", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 2245, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1827, 91),
      ))
    }

@delegate:ResourceContentHash(1_721_167_828)
internal val Res.string.auth_banner_offline: StringResource by lazy {
      StringResource("string:auth_banner_offline", "auth_banner_offline", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 2389, 155),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1919, 91),
      ))
    }

@delegate:ResourceContentHash(1_823_414_068)
internal val Res.string.auth_banner_rate_limited: StringResource by lazy {
      StringResource("string:auth_banner_rate_limited", "auth_banner_rate_limited", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 2545, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2011, 84),
      ))
    }

@delegate:ResourceContentHash(-1_043_756_953)
internal val Res.string.auth_banner_unexpected: StringResource by lazy {
      StringResource("string:auth_banner_unexpected", "auth_banner_unexpected", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 2686, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2096, 82),
      ))
    }

@delegate:ResourceContentHash(-199_235_269)
internal val Res.string.auth_banner_upgrade_required: StringResource by lazy {
      StringResource("string:auth_banner_upgrade_required", "auth_banner_upgrade_required", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 2813, 192),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2179, 120),
      ))
    }

@delegate:ResourceContentHash(-347_039_336)
internal val Res.string.chat_action_cancel: StringResource by lazy {
      StringResource("string:chat_action_cancel", "chat_action_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 2070, 42),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 1529, 34),
      ))
    }

@delegate:ResourceContentHash(-538_194_959)
internal val Res.string.chat_action_close: StringResource by lazy {
      StringResource("string:chat_action_close", "chat_action_close", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 2113, 45),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 1564, 33),
      ))
    }

@delegate:ResourceContentHash(356_191_502)
internal val Res.string.chat_action_copy: StringResource by lazy {
      StringResource("string:chat_action_copy", "chat_action_copy", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 2159, 52),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 1598, 32),
      ))
    }

@delegate:ResourceContentHash(2_122_233_061)
internal val Res.string.chat_action_delete: StringResource by lazy {
      StringResource("string:chat_action_delete", "chat_action_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 2212, 46),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 1631, 34),
      ))
    }

@delegate:ResourceContentHash(1_095_121_117)
internal val Res.string.chat_action_edit: StringResource by lazy {
      StringResource("string:chat_action_edit", "chat_action_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 2259, 60),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 1666, 32),
      ))
    }

@delegate:ResourceContentHash(-1_293_030_055)
internal val Res.string.chat_action_forward: StringResource by lazy {
      StringResource("string:chat_action_forward", "chat_action_forward", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 2320, 51),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 1699, 39),
      ))
    }

@delegate:ResourceContentHash(862_175_889)
internal val Res.string.chat_action_keep: StringResource by lazy {
      StringResource("string:chat_action_keep", "chat_action_keep", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 2372, 48),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 1739, 36),
      ))
    }

@delegate:ResourceContentHash(739_223_679)
internal val Res.string.chat_action_pin: StringResource by lazy {
      StringResource("string:chat_action_pin", "chat_action_pin", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 2421, 47),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 1776, 27),
      ))
    }

@delegate:ResourceContentHash(-1_750_807_329)
internal val Res.string.chat_action_reply: StringResource by lazy {
      StringResource("string:chat_action_reply", "chat_action_reply", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 2469, 49),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 1804, 33),
      ))
    }

@delegate:ResourceContentHash(-670_978_253)
internal val Res.string.chat_action_report: StringResource by lazy {
      StringResource("string:chat_action_report", "chat_action_report", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 2519, 58),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 1838, 34),
      ))
    }

@delegate:ResourceContentHash(1_796_747_229)
internal val Res.string.chat_action_retry: StringResource by lazy {
      StringResource("string:chat_action_retry", "chat_action_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 2578, 49),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 1873, 37),
      ))
    }

@delegate:ResourceContentHash(368_151_000)
internal val Res.string.chat_action_select: StringResource by lazy {
      StringResource("string:chat_action_select", "chat_action_select", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 2628, 46),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 1911, 34),
      ))
    }

@delegate:ResourceContentHash(523_974_052)
internal val Res.string.chat_action_unpin: StringResource by lazy {
      StringResource("string:chat_action_unpin", "chat_action_unpin", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 2675, 49),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 1946, 33),
      ))
    }

@delegate:ResourceContentHash(1_687_784_585)
internal val Res.string.chat_attach_image: StringResource by lazy {
      StringResource("string:chat_attach_image", "chat_attach_image", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 2725, 85),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 1980, 45),
      ))
    }

@delegate:ResourceContentHash(-190_044_963)
internal val Res.string.chat_back: StringResource by lazy {
      StringResource("string:chat_back", "chat_back", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 2811, 33),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 2026, 25),
      ))
    }

@delegate:ResourceContentHash(1_879_933_439)
internal val Res.string.chat_banner_load_refused: StringResource by lazy {
      StringResource("string:chat_banner_load_refused", "chat_banner_load_refused", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 2845, 108),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 2052, 64),
      ))
    }

@delegate:ResourceContentHash(-398_898_549)
internal val Res.string.chat_banner_stale_detail: StringResource by lazy {
      StringResource("string:chat_banner_stale_detail", "chat_banner_stale_detail", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 2954, 128),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 2117, 92),
      ))
    }

@delegate:ResourceContentHash(709_871_116)
internal val Res.string.chat_banner_stale_offline: StringResource by lazy {
      StringResource("string:chat_banner_stale_offline", "chat_banner_stale_offline", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 3083, 157),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 2210, 105),
      ))
    }

@delegate:ResourceContentHash(1_068_352_840)
internal val Res.string.chat_banner_stale_refused: StringResource by lazy {
      StringResource("string:chat_banner_stale_refused", "chat_banner_stale_refused", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 3241, 213),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 2316, 129),
      ))
    }

@delegate:ResourceContentHash(765_007_434)
internal val Res.string.chat_banner_stale_timeout: StringResource by lazy {
      StringResource("string:chat_banner_stale_timeout", "chat_banner_stale_timeout", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 3455, 201),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 2446, 133),
      ))
    }

@delegate:ResourceContentHash(-2_096_761_861)
internal val Res.string.chat_composer_placeholder_plain: StringResource by lazy {
      StringResource("string:chat_composer_placeholder_plain", "chat_composer_placeholder_plain", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 3657, 63),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 2580, 51),
      ))
    }

@delegate:ResourceContentHash(-1_349_087_600)
internal val Res.string.chat_composer_placeholder_titled: StringResource by lazy {
      StringResource("string:chat_composer_placeholder_titled", "chat_composer_placeholder_titled", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 3721, 88),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 2632, 60),
      ))
    }

@delegate:ResourceContentHash(-1_746_046_300)
internal val Res.string.chat_composer_placeholder_user: StringResource by lazy {
      StringResource("string:chat_composer_placeholder_user", "chat_composer_placeholder_user", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 3810, 86),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 2693, 62),
      ))
    }

@delegate:ResourceContentHash(471_870_661)
internal val Res.string.chat_day_fri: StringResource by lazy {
      StringResource("string:chat_day_fri", "chat_day_fri", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 3897, 28),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 2756, 24),
      ))
    }

@delegate:ResourceContentHash(456_475_880)
internal val Res.string.chat_day_mon: StringResource by lazy {
      StringResource("string:chat_day_mon", "chat_day_mon", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 3926, 28),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 2781, 24),
      ))
    }

@delegate:ResourceContentHash(-1_385_701_531)
internal val Res.string.chat_day_sat: StringResource by lazy {
      StringResource("string:chat_day_sat", "chat_day_sat", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 3955, 28),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 2806, 24),
      ))
    }

@delegate:ResourceContentHash(439_051_283)
internal val Res.string.chat_day_sun: StringResource by lazy {
      StringResource("string:chat_day_sun", "chat_day_sun", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 3984, 28),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 2831, 24),
      ))
    }

@delegate:ResourceContentHash(-512_141_549)
internal val Res.string.chat_day_thu: StringResource by lazy {
      StringResource("string:chat_day_thu", "chat_day_thu", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 4013, 28),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 2856, 24),
      ))
    }

@delegate:ResourceContentHash(1_773_032_597)
internal val Res.string.chat_day_today: StringResource by lazy {
      StringResource("string:chat_day_today", "chat_day_today", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 4042, 42),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 2881, 30),
      ))
    }

@delegate:ResourceContentHash(439_756_648)
internal val Res.string.chat_day_tue: StringResource by lazy {
      StringResource("string:chat_day_tue", "chat_day_tue", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 4085, 28),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 2912, 24),
      ))
    }

@delegate:ResourceContentHash(-1_368_600_942)
internal val Res.string.chat_day_wed: StringResource by lazy {
      StringResource("string:chat_day_wed", "chat_day_wed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 4114, 28),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 2937, 24),
      ))
    }

@delegate:ResourceContentHash(26_816_387)
internal val Res.string.chat_day_yesterday: StringResource by lazy {
      StringResource("string:chat_day_yesterday", "chat_day_yesterday", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 4143, 42),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 2962, 38),
      ))
    }

@delegate:ResourceContentHash(349_330_792)
internal val Res.string.chat_delete_confirm_everyone: StringResource by lazy {
      StringResource("string:chat_delete_confirm_everyone", "chat_delete_confirm_everyone", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 4186, 232),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 3001, 144),
      ))
    }

@delegate:ResourceContentHash(1_397_749_221)
internal val Res.string.chat_delete_confirm_self: StringResource by lazy {
      StringResource("string:chat_delete_confirm_self", "chat_delete_confirm_self", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 4419, 228),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 3146, 104),
      ))
    }

@delegate:ResourceContentHash(-969_361_904)
internal val Res.string.chat_delete_confirm_unsent: StringResource by lazy {
      StringResource("string:chat_delete_confirm_unsent", "chat_delete_confirm_unsent", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 4648, 218),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 3251, 126),
      ))
    }

@delegate:ResourceContentHash(995_201_882)
internal val Res.string.chat_delete_failed: StringResource by lazy {
      StringResource("string:chat_delete_failed", "chat_delete_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 4867, 98),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 3378, 66),
      ))
    }

@delegate:ResourceContentHash(1_813_703_541)
internal val Res.string.chat_delete_for_everyone: StringResource by lazy {
      StringResource("string:chat_delete_for_everyone", "chat_delete_for_everyone", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 4966, 68),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 3445, 60),
      ))
    }

@delegate:ResourceContentHash(2_042_925_532)
internal val Res.string.chat_delete_for_me: StringResource by lazy {
      StringResource("string:chat_delete_for_me", "chat_delete_for_me", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 5035, 62),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 3506, 46),
      ))
    }

@delegate:ResourceContentHash(1_549_333_573)
internal val Res.string.chat_delete_forbidden: StringResource by lazy {
      StringResource("string:chat_delete_forbidden", "chat_delete_forbidden", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 5098, 117),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 3553, 89),
      ))
    }

@delegate:ResourceContentHash(-794_478_887)
internal val Res.string.chat_delete_selected_confirm: StringResource by lazy {
      StringResource("string:chat_delete_selected_confirm", "chat_delete_selected_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 5216, 108),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 3643, 76),
      ))
    }

@delegate:ResourceContentHash(-596_062_656)
internal val Res.string.chat_delete_too_old: StringResource by lazy {
      StringResource("string:chat_delete_too_old", "chat_delete_too_old", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 5325, 163),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 3720, 91),
      ))
    }

@delegate:ResourceContentHash(1_971_889_921)
internal val Res.string.chat_edit_conflict: StringResource by lazy {
      StringResource("string:chat_edit_conflict", "chat_edit_conflict", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 5489, 210),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 3812, 134),
      ))
    }

@delegate:ResourceContentHash(474_718_876)
internal val Res.string.chat_edit_failed: StringResource by lazy {
      StringResource("string:chat_edit_failed", "chat_edit_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 5700, 128),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 3947, 72),
      ))
    }

@delegate:ResourceContentHash(1_033_009_533)
internal val Res.string.chat_edit_forbidden: StringResource by lazy {
      StringResource("string:chat_edit_forbidden", "chat_edit_forbidden", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 5829, 135),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 4020, 79),
      ))
    }

@delegate:ResourceContentHash(-1_655_092_732)
internal val Res.string.chat_edit_save: StringResource by lazy {
      StringResource("string:chat_edit_save", "chat_edit_save", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 5965, 74),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 4100, 50),
      ))
    }

@delegate:ResourceContentHash(-338_925_670)
internal val Res.string.chat_edited: StringResource by lazy {
      StringResource("string:chat_edited", "chat_edited", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 6040, 43),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 4151, 27),
      ))
    }

@delegate:ResourceContentHash(920_407_777)
internal val Res.string.chat_editing_message: StringResource by lazy {
      StringResource("string:chat_editing_message", "chat_editing_message", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 6084, 92),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 4179, 48),
      ))
    }

@delegate:ResourceContentHash(259_051_628)
internal val Res.string.chat_empty_body: StringResource by lazy {
      StringResource("string:chat_empty_body", "chat_empty_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 6177, 91),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 4228, 39),
      ))
    }

@delegate:ResourceContentHash(-1_351_092_861)
internal val Res.string.chat_empty_title: StringResource by lazy {
      StringResource("string:chat_empty_title", "chat_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 6269, 72),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 4268, 48),
      ))
    }

@delegate:ResourceContentHash(-1_762_169_556)
internal val Res.string.chat_forward_empty: StringResource by lazy {
      StringResource("string:chat_forward_empty", "chat_forward_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 6342, 74),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 4317, 50),
      ))
    }

@delegate:ResourceContentHash(455_120_023)
internal val Res.string.chat_forward_failed: StringResource by lazy {
      StringResource("string:chat_forward_failed", "chat_forward_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 6417, 107),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 4368, 71),
      ))
    }

@delegate:ResourceContentHash(1_387_863_226)
internal val Res.string.chat_forward_search: StringResource by lazy {
      StringResource("string:chat_forward_search", "chat_forward_search", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 6525, 55),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 4440, 43),
      ))
    }

@delegate:ResourceContentHash(1_290_045_688)
internal val Res.string.chat_forward_sent: StringResource by lazy {
      StringResource("string:chat_forward_sent", "chat_forward_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 6581, 77),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 4484, 53),
      ))
    }

@delegate:ResourceContentHash(-83_190_141)
internal val Res.string.chat_forward_title: StringResource by lazy {
      StringResource("string:chat_forward_title", "chat_forward_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 6659, 54),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 4538, 42),
      ))
    }

@delegate:ResourceContentHash(-826_084_528)
internal val Res.string.chat_image_failed: StringResource by lazy {
      StringResource("string:chat_image_failed", "chat_image_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 6714, 109),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 4581, 57),
      ))
    }

@delegate:ResourceContentHash(496_007_476)
internal val Res.string.chat_image_rejected: StringResource by lazy {
      StringResource("string:chat_image_rejected", "chat_image_rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 6824, 111),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 4639, 63),
      ))
    }

@delegate:ResourceContentHash(-679_536_339)
internal val Res.string.chat_message_deleted_body: StringResource by lazy {
      StringResource("string:chat_message_deleted_body", "chat_message_deleted_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 6936, 77),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 4703, 65),
      ))
    }

@delegate:ResourceContentHash(1_231_473_814)
internal val Res.string.chat_message_options: StringResource by lazy {
      StringResource("string:chat_message_options", "chat_message_options", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 7014, 84),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 4769, 48),
      ))
    }

@delegate:ResourceContentHash(1_107_953_914)
internal val Res.string.chat_message_react: StringResource by lazy {
      StringResource("string:chat_message_react", "chat_message_react", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 7099, 70),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 4818, 50),
      ))
    }

@delegate:ResourceContentHash(359_156_764)
internal val Res.string.chat_offline: StringResource by lazy {
      StringResource("string:chat_offline", "chat_offline", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 7170, 56),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 4869, 40),
      ))
    }

@delegate:ResourceContentHash(1_815_164_780)
internal val Res.string.chat_open_profile: StringResource by lazy {
      StringResource("string:chat_open_profile", "chat_open_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 7227, 65),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 4910, 41),
      ))
    }

@delegate:ResourceContentHash(856_236_392)
internal val Res.string.chat_outbox_failed: StringResource by lazy {
      StringResource("string:chat_outbox_failed", "chat_outbox_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 7293, 230),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 4952, 114),
      ))
    }

@delegate:ResourceContentHash(-1_689_576_623)
internal val Res.string.chat_photo: StringResource by lazy {
      StringResource("string:chat_photo", "chat_photo", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 7667, 46),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 5162, 26),
      ))
    }

@delegate:ResourceContentHash(-60_441_827)
internal val Res.string.chat_photo_open: StringResource by lazy {
      StringResource("string:chat_photo_open", "chat_photo_open", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 7524, 71),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 5067, 39),
      ))
    }

@delegate:ResourceContentHash(1_925_948_816)
internal val Res.string.chat_photo_unavailable: StringResource by lazy {
      StringResource("string:chat_photo_unavailable", "chat_photo_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 7596, 70),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 5107, 54),
      ))
    }

@delegate:ResourceContentHash(567_570_456)
internal val Res.string.chat_pin_failed: StringResource by lazy {
      StringResource("string:chat_pin_failed", "chat_pin_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 7714, 103),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 5189, 59),
      ))
    }

@delegate:ResourceContentHash(-578_434_381)
internal val Res.string.chat_presence_last_seen_date: StringResource by lazy {
      StringResource("string:chat_presence_last_seen_date", "chat_presence_last_seen_date", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 7818, 92),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 5249, 60),
      ))
    }

@delegate:ResourceContentHash(2_037_844_606)
internal val Res.string.chat_presence_last_seen_today: StringResource by lazy {
      StringResource("string:chat_presence_last_seen_today", "chat_presence_last_seen_today", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 7911, 97),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 5310, 61),
      ))
    }

@delegate:ResourceContentHash(-1_905_767_242)
internal val Res.string.chat_presence_last_seen_yesterday: StringResource by lazy {
      StringResource("string:chat_presence_last_seen_yesterday", "chat_presence_last_seen_yesterday", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 8009, 117),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 5372, 77),
      ))
    }

@delegate:ResourceContentHash(342_917_441)
internal val Res.string.chat_presence_online: StringResource by lazy {
      StringResource("string:chat_presence_online", "chat_presence_online", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 8127, 44),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 5450, 36),
      ))
    }

@delegate:ResourceContentHash(1_431_418_906)
internal val Res.string.chat_preview_body_deleted: StringResource by lazy {
      StringResource("string:chat_preview_body_deleted", "chat_preview_body_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 8172, 77),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 5487, 53),
      ))
    }

@delegate:ResourceContentHash(-2_096_761_861)
internal val Res.string.chat_preview_body_none: StringResource by lazy {
      StringResource("string:chat_preview_body_none", "chat_preview_body_none", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 8250, 54),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 5541, 42),
      ))
    }

@delegate:ResourceContentHash(339_287_260)
internal val Res.string.chat_preview_body_photo: StringResource by lazy {
      StringResource("string:chat_preview_body_photo", "chat_preview_body_photo", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 8305, 71),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 5584, 47),
      ))
    }

@delegate:ResourceContentHash(561_399_776)
internal val Res.string.chat_preview_from: StringResource by lazy {
      StringResource("string:chat_preview_from", "chat_preview_from", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 8377, 41),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 5632, 41),
      ))
    }

@delegate:ResourceContentHash(511_156_935)
internal val Res.string.chat_preview_own: StringResource by lazy {
      StringResource("string:chat_preview_own", "chat_preview_own", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 8454, 36),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 5709, 36),
      ))
    }

@delegate:ResourceContentHash(49_296_280)
internal val Res.string.chat_preview_own_title: StringResource by lazy {
      StringResource("string:chat_preview_own_title", "chat_preview_own_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 8419, 34),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 5674, 34),
      ))
    }

@delegate:ResourceContentHash(-1_427_966_567)
internal val Res.string.chat_reaction_add: StringResource by lazy {
      StringResource("string:chat_reaction_add", "chat_reaction_add", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 8491, 69),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 5746, 41),
      ))
    }

@delegate:ResourceContentHash(946_044_604)
internal val Res.string.chat_reaction_angry: StringResource by lazy {
      StringResource("string:chat_reaction_angry", "chat_reaction_angry", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 8561, 67),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 5788, 47),
      ))
    }

@delegate:ResourceContentHash(-1_843_910_025)
internal val Res.string.chat_reaction_celebration: StringResource by lazy {
      StringResource("string:chat_reaction_celebration", "chat_reaction_celebration", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 8629, 77),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 5836, 61),
      ))
    }

@delegate:ResourceContentHash(70_528_004)
internal val Res.string.chat_reaction_eyes: StringResource by lazy {
      StringResource("string:chat_reaction_eyes", "chat_reaction_eyes", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 8707, 62),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 5898, 46),
      ))
    }

@delegate:ResourceContentHash(-648_715_796)
internal val Res.string.chat_reaction_failed: StringResource by lazy {
      StringResource("string:chat_reaction_failed", "chat_reaction_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 8770, 168),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 5945, 92),
      ))
    }

@delegate:ResourceContentHash(473_293_074)
internal val Res.string.chat_reaction_fire: StringResource by lazy {
      StringResource("string:chat_reaction_fire", "chat_reaction_fire", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 8939, 62),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 6038, 46),
      ))
    }

@delegate:ResourceContentHash(-1_333_106_903)
internal val Res.string.chat_reaction_heart: StringResource by lazy {
      StringResource("string:chat_reaction_heart", "chat_reaction_heart", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 9002, 67),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 6085, 47),
      ))
    }

@delegate:ResourceContentHash(1_665_068_332)
internal val Res.string.chat_reaction_laugh: StringResource by lazy {
      StringResource("string:chat_reaction_laugh", "chat_reaction_laugh", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 9070, 59),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 6133, 51),
      ))
    }

@delegate:ResourceContentHash(1_561_583_776)
internal val Res.string.chat_reaction_pray: StringResource by lazy {
      StringResource("string:chat_reaction_pray", "chat_reaction_pray", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 9130, 82),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 6185, 50),
      ))
    }

@delegate:ResourceContentHash(675_292_829)
internal val Res.string.chat_reaction_remove: StringResource by lazy {
      StringResource("string:chat_reaction_remove", "chat_reaction_remove", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 9213, 64),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 6236, 48),
      ))
    }

@delegate:ResourceContentHash(-495_016_445)
internal val Res.string.chat_reaction_sad: StringResource by lazy {
      StringResource("string:chat_reaction_sad", "chat_reaction_sad", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 9278, 65),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 6285, 41),
      ))
    }

@delegate:ResourceContentHash(-325_332_656)
internal val Res.string.chat_reaction_surprised: StringResource by lazy {
      StringResource("string:chat_reaction_surprised", "chat_reaction_surprised", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 9344, 79),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 6327, 55),
      ))
    }

@delegate:ResourceContentHash(-1_683_334_888)
internal val Res.string.chat_reaction_thinking: StringResource by lazy {
      StringResource("string:chat_reaction_thinking", "chat_reaction_thinking", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 9424, 82),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 6383, 54),
      ))
    }

@delegate:ResourceContentHash(-17_905_938)
internal val Res.string.chat_reaction_thumbs_down: StringResource by lazy {
      StringResource("string:chat_reaction_thumbs_down", "chat_reaction_thumbs_down", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 9507, 85),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 6438, 61),
      ))
    }

@delegate:ResourceContentHash(960_353_386)
internal val Res.string.chat_reaction_thumbs_up: StringResource by lazy {
      StringResource("string:chat_reaction_thumbs_up", "chat_reaction_thumbs_up", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 9593, 75),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 6500, 55),
      ))
    }

@delegate:ResourceContentHash(-951_844_455)
internal val Res.string.chat_reactions_more: StringResource by lazy {
      StringResource("string:chat_reactions_more", "chat_reactions_more", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 9669, 63),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 6556, 47),
      ))
    }

@delegate:ResourceContentHash(-1_806_178_380)
internal val Res.string.chat_refresh: StringResource by lazy {
      StringResource("string:chat_refresh", "chat_refresh", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 9785, 44),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 6644, 32),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("auth_banner_account_suspended", Res.string.auth_banner_account_suspended)
  map.put("auth_banner_code_rejected", Res.string.auth_banner_code_rejected)
  map.put("auth_banner_invalid_credentials", Res.string.auth_banner_invalid_credentials)
  map.put("auth_banner_offline", Res.string.auth_banner_offline)
  map.put("auth_banner_rate_limited", Res.string.auth_banner_rate_limited)
  map.put("auth_banner_unexpected", Res.string.auth_banner_unexpected)
  map.put("auth_banner_upgrade_required", Res.string.auth_banner_upgrade_required)
  map.put("chat_action_cancel", Res.string.chat_action_cancel)
  map.put("chat_action_close", Res.string.chat_action_close)
  map.put("chat_action_copy", Res.string.chat_action_copy)
  map.put("chat_action_delete", Res.string.chat_action_delete)
  map.put("chat_action_edit", Res.string.chat_action_edit)
  map.put("chat_action_forward", Res.string.chat_action_forward)
  map.put("chat_action_keep", Res.string.chat_action_keep)
  map.put("chat_action_pin", Res.string.chat_action_pin)
  map.put("chat_action_reply", Res.string.chat_action_reply)
  map.put("chat_action_report", Res.string.chat_action_report)
  map.put("chat_action_retry", Res.string.chat_action_retry)
  map.put("chat_action_select", Res.string.chat_action_select)
  map.put("chat_action_unpin", Res.string.chat_action_unpin)
  map.put("chat_attach_image", Res.string.chat_attach_image)
  map.put("chat_back", Res.string.chat_back)
  map.put("chat_banner_load_refused", Res.string.chat_banner_load_refused)
  map.put("chat_banner_stale_detail", Res.string.chat_banner_stale_detail)
  map.put("chat_banner_stale_offline", Res.string.chat_banner_stale_offline)
  map.put("chat_banner_stale_refused", Res.string.chat_banner_stale_refused)
  map.put("chat_banner_stale_timeout", Res.string.chat_banner_stale_timeout)
  map.put("chat_composer_placeholder_plain", Res.string.chat_composer_placeholder_plain)
  map.put("chat_composer_placeholder_titled", Res.string.chat_composer_placeholder_titled)
  map.put("chat_composer_placeholder_user", Res.string.chat_composer_placeholder_user)
  map.put("chat_day_fri", Res.string.chat_day_fri)
  map.put("chat_day_mon", Res.string.chat_day_mon)
  map.put("chat_day_sat", Res.string.chat_day_sat)
  map.put("chat_day_sun", Res.string.chat_day_sun)
  map.put("chat_day_thu", Res.string.chat_day_thu)
  map.put("chat_day_today", Res.string.chat_day_today)
  map.put("chat_day_tue", Res.string.chat_day_tue)
  map.put("chat_day_wed", Res.string.chat_day_wed)
  map.put("chat_day_yesterday", Res.string.chat_day_yesterday)
  map.put("chat_delete_confirm_everyone", Res.string.chat_delete_confirm_everyone)
  map.put("chat_delete_confirm_self", Res.string.chat_delete_confirm_self)
  map.put("chat_delete_confirm_unsent", Res.string.chat_delete_confirm_unsent)
  map.put("chat_delete_failed", Res.string.chat_delete_failed)
  map.put("chat_delete_for_everyone", Res.string.chat_delete_for_everyone)
  map.put("chat_delete_for_me", Res.string.chat_delete_for_me)
  map.put("chat_delete_forbidden", Res.string.chat_delete_forbidden)
  map.put("chat_delete_selected_confirm", Res.string.chat_delete_selected_confirm)
  map.put("chat_delete_too_old", Res.string.chat_delete_too_old)
  map.put("chat_edit_conflict", Res.string.chat_edit_conflict)
  map.put("chat_edit_failed", Res.string.chat_edit_failed)
  map.put("chat_edit_forbidden", Res.string.chat_edit_forbidden)
  map.put("chat_edit_save", Res.string.chat_edit_save)
  map.put("chat_edited", Res.string.chat_edited)
  map.put("chat_editing_message", Res.string.chat_editing_message)
  map.put("chat_empty_body", Res.string.chat_empty_body)
  map.put("chat_empty_title", Res.string.chat_empty_title)
  map.put("chat_forward_empty", Res.string.chat_forward_empty)
  map.put("chat_forward_failed", Res.string.chat_forward_failed)
  map.put("chat_forward_search", Res.string.chat_forward_search)
  map.put("chat_forward_sent", Res.string.chat_forward_sent)
  map.put("chat_forward_title", Res.string.chat_forward_title)
  map.put("chat_image_failed", Res.string.chat_image_failed)
  map.put("chat_image_rejected", Res.string.chat_image_rejected)
  map.put("chat_message_deleted_body", Res.string.chat_message_deleted_body)
  map.put("chat_message_options", Res.string.chat_message_options)
  map.put("chat_message_react", Res.string.chat_message_react)
  map.put("chat_offline", Res.string.chat_offline)
  map.put("chat_open_profile", Res.string.chat_open_profile)
  map.put("chat_outbox_failed", Res.string.chat_outbox_failed)
  map.put("chat_photo", Res.string.chat_photo)
  map.put("chat_photo_open", Res.string.chat_photo_open)
  map.put("chat_photo_unavailable", Res.string.chat_photo_unavailable)
  map.put("chat_pin_failed", Res.string.chat_pin_failed)
  map.put("chat_presence_last_seen_date", Res.string.chat_presence_last_seen_date)
  map.put("chat_presence_last_seen_today", Res.string.chat_presence_last_seen_today)
  map.put("chat_presence_last_seen_yesterday", Res.string.chat_presence_last_seen_yesterday)
  map.put("chat_presence_online", Res.string.chat_presence_online)
  map.put("chat_preview_body_deleted", Res.string.chat_preview_body_deleted)
  map.put("chat_preview_body_none", Res.string.chat_preview_body_none)
  map.put("chat_preview_body_photo", Res.string.chat_preview_body_photo)
  map.put("chat_preview_from", Res.string.chat_preview_from)
  map.put("chat_preview_own", Res.string.chat_preview_own)
  map.put("chat_preview_own_title", Res.string.chat_preview_own_title)
  map.put("chat_reaction_add", Res.string.chat_reaction_add)
  map.put("chat_reaction_angry", Res.string.chat_reaction_angry)
  map.put("chat_reaction_celebration", Res.string.chat_reaction_celebration)
  map.put("chat_reaction_eyes", Res.string.chat_reaction_eyes)
  map.put("chat_reaction_failed", Res.string.chat_reaction_failed)
  map.put("chat_reaction_fire", Res.string.chat_reaction_fire)
  map.put("chat_reaction_heart", Res.string.chat_reaction_heart)
  map.put("chat_reaction_laugh", Res.string.chat_reaction_laugh)
  map.put("chat_reaction_pray", Res.string.chat_reaction_pray)
  map.put("chat_reaction_remove", Res.string.chat_reaction_remove)
  map.put("chat_reaction_sad", Res.string.chat_reaction_sad)
  map.put("chat_reaction_surprised", Res.string.chat_reaction_surprised)
  map.put("chat_reaction_thinking", Res.string.chat_reaction_thinking)
  map.put("chat_reaction_thumbs_down", Res.string.chat_reaction_thumbs_down)
  map.put("chat_reaction_thumbs_up", Res.string.chat_reaction_thumbs_up)
  map.put("chat_reactions_more", Res.string.chat_reactions_more)
  map.put("chat_refresh", Res.string.chat_refresh)
}
